import React, { useState } from "react";
import { TextField, Button, Typography, Box, Link, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom"; // or from "next/link" if Next.js

const LoginUi = ({ email, setEmail, password, setPassword, onLogin, loading, buttonText }) => {
  return (
    <Box
      sx={{
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        fontFamily: '"Quicksand", sans-serif',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#111",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        className="ring"
        sx={{
          position: "relative",
          width: "500px",
          height: "500px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          component="i"
          sx={{
            position: "absolute",
            inset: 0,
            border: "2px solid #fff",
            transition: "0.5s",
            borderRadius: "38% 62% 63% 37% / 41% 44% 56% 59%",
            animation: "animate 6s linear infinite",
            "--clr": "#00ff0a",
          }}
        ></Box>
        <Box
          component="i"
          sx={{
            position: "absolute",
            inset: 0,
            border: "2px solid #fff",
            transition: "0.5s",
            borderRadius: "41% 44% 56% 59% / 38% 62% 63% 37%",
            animation: "animate 4s linear infinite",
            "--clr": "#ff0057",
          }}
        ></Box>
        <Box
          component="i"
          sx={{
            position: "absolute",
            inset: 0,
            border: "2px solid #fff",
            transition: "0.5s",
            borderRadius: "41% 44% 56% 59% / 38% 62% 63% 37%",
            animation: "animate2 10s linear infinite",
            "--clr": "#fffd44",
          }}
        ></Box>
        <Box
          className="login"
          sx={{
            position: "absolute",
            width: "340px",
            height: "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "20px",
            backgroundColor: "#fff",
            borderRadius: "16px",
            padding: "20px",
            textAlign: "center",
            // backgroundColor: "#01021a",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "1.5em",
              fontWeight: 600,
              color: "#000",
              mb: 2,
            }}
          >
            Login Now
          </Typography>
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            fullWidth
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "40px",
                "& fieldset": { borderColor: "#000" },
                "&:hover fieldset": { borderColor: "#000" },
                "&.Mui-focused fieldset": { borderColor: "#0078ff" },
              },
              "& .MuiInputLabel-root": { color: "rgba(0, 0, 0, 0.75)" },
              "& .MuiInputBase-input": { color: "#000" },
            }}
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            fullWidth
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "40px",
                "& fieldset": { borderColor: "#000" },
                "&:hover fieldset": { borderColor: "#000" },
                "&.Mui-focused fieldset": { borderColor: "#0078ff" },
              },
              "& .MuiInputLabel-root": { color: "rgba(0, 0, 0, 0.75)" },
              "& .MuiInputBase-input": { color: "#000" },
            }}
          />
          <Button
            variant="contained"
            fullWidth
            onClick={onLogin}
            disabled={loading}
            sx={{
              background: "linear-gradient(45deg, #ff357a, #fff172)",
              borderRadius: "40px",
              height: "40px",
              mb: 2,
              textTransform: "none",
              "&:hover": {
                background: "linear-gradient(45deg, #e02f6d, #e0d66b)",
              },
            }}
          >
            <Typography sx={{ fontSize: "1.2em", fontWeight: 600, color: "#fff" }}>
              {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Login In"}
            </Typography>
          </Button>

          <Button
            component={RouterLink}
            to="/register"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{
              background: "linear-gradient(45deg, #ff357a, #fff172)",
              borderRadius: "40px",
              height: "40px",
              mb: 2,
              textTransform: "none",
              pointerEvents: loading ? "none" : "auto",
              "&:hover": {
                background: "linear-gradient(45deg, #e02f6d, #e0d66b)",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: "1.2em",
                fontWeight: 600,
                color: loading ? "rgba(255, 255, 255, 0.5)" : "#fff",
              }}
            >
              {"Register"}
            </Typography>
          </Button>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              padding: "0 20px",
            }}
          ></Box>
        </Box>
      </Box>
      <style>
        {`
          @keyframes animate {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          @keyframes animate2 {
            0% {
              transform: rotate(360deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }
          .ring:hover i {
            border: 6px solid var(--clr);
            filter: drop-shadow(0 0 20px var(--clr));
          }
        `}
      </style>
    </Box>
  );
};

LoginUi.propTypes = {
  email: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default LoginUi;
